import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import SimpleModal from "../../components/common/SimpleModal";
import { setIsEditAdmin, toggleAdminModal } from "./redux/adminSlice";
import AdminTable from "./components/AdminTable";
import RoomForm from "./components/form/AdminForm";
import AddIcon from "../../components/common/AddIcon";
import { useAdminQuery } from "../../graphql/apollo/query-hooks";

const AdminPage = () => {
  const dispatch = useDispatch();
  const { isOpenModal } = useSelector((state) => state.admin);
  const { adminList } = useAdminQuery();

  const handleAdd = () => {
    dispatch(setIsEditAdmin(false));
    dispatch(toggleAdminModal());
  };

  const handleClose = () => dispatch(toggleAdminModal());

  return (
    <>
      <SimpleModal
        show={isOpenModal}
        handleClose={handleClose}
        title="ຈັດການແອດມິນ"
        size="lg"
      >
        <RoomForm handleClose={handleClose} />
      </SimpleModal>
      <Row className="lao">
        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title>
                <h3 className="p-1">ຈັດການຂໍ້ມູນຫ້ອງເກມ</h3>
              </Card.Title>
              <AddIcon onClick={handleAdd} />
            </Card.Header>
            <Card.Body>
              <AdminTable data={adminList} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default AdminPage;
